import { createI18n } from "vue-i18n";

const userLang = navigator.language.split('-')[0]; 

const messages = {
	es: require("@/translates/es.json"),
	en: require("@/translates/en.json"),
	us: require("@/translates/en.json"),
};

const i18n = createI18n({
	legacy: true,
	allowComposition: true,
	globalInjection: true,
	locale: userLang,
	fallbackLocale: "en",
	messages,
});

export default i18n;
